import { render, staticRenderFns } from "./form-radio.vue?vue&type=template&id=bfad3d3c&scoped=true"
import script from "./form-radio.vue?vue&type=script&lang=js"
export * from "./form-radio.vue?vue&type=script&lang=js"
import style0 from "./form-radio.vue?vue&type=style&index=0&id=bfad3d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfad3d3c",
  null
  
)

export default component.exports